import customized from './customized';

const styles = [
	{ slug: 'customized', label: 'Customized', styles: customized },
	{ slug: 'original', label: 'Original', styles: [] },
];

export default styles;
